import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppSettings {
  app_config: any = {
    protocol: 'https',
    domain: 'services.commercengine.dev',
    base_url: 'https://services.commercengine.dev/api/v1/admin/tenant/',
    subfolderFirebase: 'admin',
  };
}
